const ACTIONS = {
  FETCH_CHARGER_STATUS_INIT: "FETCH_CHARGER_STATUS_INIT",
  FETCH_CHARGER_STATUS_SUCCESS: "FETCH_CHARGER_STATUS_SUCCESS",
  FETCH_CHARGER_STATUS_FAILURE: "FETCH_CHARGER_STATUS_FAILURE",
  FETCH_CHARGER_MATRIX_INIT: "FETCH_CHARGER_MATRIX_INIT",
  FETCH_CHARGER_MATRIX_SUCCESS: "FETCH_CHARGER_MATRIX_SUCCESS",
  FETCH_CHARGER_MATRIX_FAILURE: "FETCH_CHARGER_MATRIX_FAILURE",
};

export default ACTIONS;
